import React, { useEffect, useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import { LeftGrid } from '../Episode/Episode.Styled';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { getVerificationMonthData } from '../../redux/verification/verificationGetMonth';
import BackIcon from '../common/Back/BackIcon';
import FormInputDropdown from '../common/Forms/FormDropdown';
import FormInputText from '../common/Forms/FormTextField';
import PageHeading from '../common/Heading/PageHeading';
import { ContentTitle } from '../ui/styled';
import { Auth } from 'aws-amplify';
import { useDebouncedCallback } from 'use-debounce';
import {
  emptyMonth,
  formDateFormat,
  VERIFICATION_BASE_URL,
  VERIFICATION_INSERT,
  VERIFICATION_REPORT_PROVIDERS,
  VERIFICATION_REPORT_DETAILS,
  dateFormatShort
} from '../../constants';
import moment from 'moment';
import { getStopApi, setStopApi, postStopApi } from '../../services/StopApi/StopApi';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const VerificationCreate = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const STOP_REGION = process.env.REACT_APP_STOP_REGION
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(null);
  const [progress, setProgress] = React.useState(100);
  const [printProviders, setPrintProviders] = useState([]);
  const [month, setMonth] = useState('');
  const [monthOptions, setMonthOptions] = useState(null);
  const [provider, setProvider] = useState(0);
  const [providerOptions, setProviderOptions] = useState(null);
  const verificationReferenceData = useSelector(
    (state) => state.verificationReferenceData
  );
  //console.log('### verificationReferenceData')
  //console.log(verificationReferenceData)

  const verificationListData = useSelector(
    (state) => state?.verificationListSlice
  );
  const monthDate = useSelector((state) => state.verificationMonthData);
  const verifyMasterReferenceData = useSelector(
    (state) => state.verifyMasterReferenceData
  );
  const MonthSplit =
    verificationListData?.startingMonday?.value === undefined
      ? ''
      : verificationListData?.startingMonday?.value.split('-');
  const monthJoin =
    MonthSplit === undefined ? '' : `${MonthSplit[0]}-${MonthSplit[1]}`;
  const monthNewDate =
    monthDate?.value === ''
      ? ''
      : monthDate?.filter((item) => (item.value === monthJoin ? item.id : ''));
  const newWeekDate = new Date(verificationListData?.startingMonday?.value);
  const endDateOfWeek = newWeekDate.setDate(newWeekDate.getDate() + 6);
  const sundayDate = moment(endDateOfWeek).format(formDateFormat);
  const defaultValue = {
    startingMonday: verificationListData?.startingMonday?.value,
    Month: monthNewDate === '' ? monthJoin : monthNewDate[0]?.value,
    cbpID: verificationListData?.provider?.cbpId
      ? verificationListData?.provider?.cbpId
      : verificationListData?.searchCbp,
    cbpProvider: verificationListData?.provider?.name,
    startDate: verificationListData?.startingMonday?.value,
    endDate: sundayDate,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { control } =
    useFunction;

  const startingMonday = useWatch({
    control,
    name: 'startingMonday',
  });


  let startingMondayMonth = useWatch({
    control,
    name: 'Month',
  });
  
  const startingMondayIds = verificationReferenceData?.weeks?.filter((item) =>
    item.value.split('T')[0] === startingMonday ? item.value : ''
  );

  const mondayMonth = startingMonday?.replace('T', ` `);

  useEffect(() => {
    //console.log(monthDate);
    if (user?.signInUserSession.accessToken.jwtToken) {
      if (mondayMonth) {
        FetchMonth();
      }
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    startingMonday,
  ]);

  useEffect(() => {
    setProviderOptions(
    verificationReferenceData.providers.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={item.id}
        >
          {item.value + ' - ' + item.id}
        </MenuItem>
      )  
    })
  );
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    startingMonday,
  ]);


  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const FetchMonth = () => {
    setMonth('');
    const url = `${VERIFICATION_BASE_URL}/Months/${mondayMonth}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    //console.log(url);
    //const results = getVerificationMonthData({ url, authorization });
    //console.log(results);
    //dispatch(getVerificationMonthData({ url, authorization }));

    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = axios
      .get(url, config)
      .then((response) => {
        const data = response.data.data;
        //console.log(data);
        setMonthOptions(
          data.map((item, index) => {
            return (
              <MenuItem
                key={index}
                value={item.id}
              >
                {item.value}
              </MenuItem>
            )  
          })
        );    

      })
      .catch((e) => {
        console.log(e);
        return e;
      });
  };

  const handleCreate = () => {
    //console.log(startingMonday);
    //console.log(month);

    const url = `${VERIFICATION_INSERT}?WkID=${startingMonday}&MthID=${month}&CboID=${provider}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    postStopApi({
      url,
      'payload': '',
      authorization,
    })
    .then((response) => {
      //console.log(response);
      navigate(`/weeklyVerification`);
    })
    .catch((e) => {
        console.log(e);
        alert(e);
    });
  };

  const sleep = ms => new Promise(res => setTimeout(res, ms));

  const getProviders = async () => {
    const commonParams = `${VERIFICATION_REPORT_PROVIDERS}?CBOId=${provider}&VerMthID=${month}&VerWkID=${startingMonday}`;  
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    
    const response = await getStopApi({ commonParams, authorization }).catch((e) => alert(e));
    let providers = response.data;

    for (var i = 0; i < providers.length; i++) {
      const provider = providers[i]; 
      //console.log(provider.provider.name);
      provider.details = await printDetails(provider.provider.cbpId, month, startingMonday);
      setProgress((i / providers.length) * 100);
      //await sleep(200);
    }
    
    console.log("month")
    console.log(month)

    console.log("all providers")
    console.log(providers)
    return providers;

  }

  const handlePrintPreview = async () => {
    setPrintProviders([]);
    setLoading(true);
    const providers = await getProviders();
    setPrintProviders(providers);
    setLoading(false);

  };

  const printDetails = async (cbpId, month, startingMonday) => {
    const commonParams = `${VERIFICATION_REPORT_DETAILS}?CBOId=${cbpId}&VerMthID=${month}&VerWkID=${startingMonday}`;  
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    const response = await getStopApi({ commonParams, authorization }).catch((e) => alert(e));
    return response.data;
  }

  const handleMonthChange = (event) => {
    //console.log(event.target.value);
    setMonth(event.target.value);
  };

  const handleProviderChange = (event) => {
    //console.log(event.target.value);
    setProvider(event.target.value);
  };

  return (
    <>
      <ContentTitle container>
        <BackIcon />
        <PageHeading title='Verification List' />
      </ContentTitle>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <FormInputDropdown
            name='startingMonday'
            control={control}
            label='Starting Monday'
            options={verificationReferenceData?.weeks}
            isWeeks={true}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="month-label">Month</InputLabel>
            <Select
              labelId="month-label"
              id="month"
              value={month}
              label="Month"
              onChange={handleMonthChange}
            >
              {monthOptions}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="provider-label">Provider</InputLabel>
            <Select
              labelId="provider-label"
              id="provider"
              value={provider}
              label="Provider"
              onChange={handleProviderChange}
            >
              {providerOptions}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            //style={{ marginRight: '10px' }}
            variant='contained'
            onClick={handleCreate}
            disabled={!month || !startingMonday}
            fullWidth
          >
            Release Verifications
          </Button>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LoadingButton
            //style={{ marginRight: '10px' }}
            variant='contained'
            onClick={handlePrintPreview}
            disabled={!month || !startingMonday}
            fullWidth
            loading={loading}
          >
            Print Preview
          </LoadingButton>
        </Grid>
      </Grid>
      {loading &&
      <Box p={1} sx={{ width: '100%' }}>
        <LinearProgressWithLabel value={progress} />
      </Box>
      }
      { printProviders.length > 0 &&
        <Grid item xs={12}>
          <Box mt={1} mx={4}>
              <Button
                variant='contained'
                onClick={() => handlePrint()}
                fullWidth
              >
                Print
              </Button>
          </Box>    
        </Grid>
      }  
      <Box p={6} ref={componentRef}>
        {
          printProviders?.map((provider, index) => (
            <>
            {/*{(index+1) % 2 == 0 &&
              <div className="page-break" />            
            }*/}
            <div key={index}>
              {
                <>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Box style={{ alignItems: 'center' }}>
                      <Typography variant="h4" align="center">
                        Weekly Verifications {moment(startingMonday).format(dateFormatShort)} - {moment(startingMonday).add(6, 'd').format(dateFormatShort)}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <Typography variant='h5'>Provider: {provider.provider?.name}</Typography>
                  </Grid>
                  <LeftGrid item xs={12} sm={5}>
                    <Typography variant='h5'>Verification Contact: {provider.provider?.verificationContact?.name}</Typography>
                  </LeftGrid>
                  <Grid item xs={12} sm={7}>
                    <Typography variant='h5'>Provider ID: {provider.provider?.cbpId}</Typography>
                  </Grid>
                  <LeftGrid item xs={12} sm={5}>
                    <Typography variant='h5'>Verification Phone: {provider.provider?.verificationContact?.phone}</Typography>
                  </LeftGrid>
                </Grid>
                
                
              
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow
                          sx={{backgroundColor: '#747070'}}
                        >
                          <TableCell width={250} sx={{color: '#fff', padding: '2px'}}>Participant</TableCell>
                          <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>CDC #</TableCell>
                          <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Epd ID</TableCell>
                          <TableCell align={'center'} width={100} sx={{color: '#fff', padding: '2px'}}>Tmt Type</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Monday {moment(startingMonday).format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Tuesday {moment(startingMonday).add(1, 'd').format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Wednesday {moment(startingMonday).add(2, 'd').format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Thursday {moment(startingMonday).add(3, 'd').format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Friday {moment(startingMonday).add(4, 'd').format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Saturday {moment(startingMonday).add(5, 'd').format(dateFormatShort)}</TableCell>
                          <TableCell width={90} sx={{color: '#fff', padding: '2px'}}>Sunday {moment(startingMonday).add(6, 'd').format(dateFormatShort)}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>                          
                        {
                          provider.details?.verificationDataList?.map((participant, index) => {
                            return(
                              <TableRow
                                key={index}
                                sx={{ '&:nth-of-type(odd)': {backgroundColor: '#eee'}, '&:last-child td, &:last-child th': { border: 0} }}
                              >
                                <TableCell sx={{padding: '2px'}}>
                                  <Typography sx={{padding: '0px', fontWeight: '800'}}>{participant.verPrtKey}</Typography>                                  
                                  <List sx={{padding: '0px'}} disablePadding>
                                    <ListItem sx={{padding: '0px'}} disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={'Ath Start: ' + (participant.verSapAthStartDate ? moment(participant.verSapAthStartDate).format(dateFormatShort) : '')} />
                                    </ListItem>
                                    <ListItem sx={{padding: '0px'}} disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={'Ath Adm: ' + (participant.verSapAthAdmDate ? moment(participant.verSapAthAdmDate).format(dateFormatShort) : '')} />
                                    </ListItem>
                                    <ListItem sx={{padding: '0px'}} disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={'Ath Dch: ' + (participant.verSapAthDchDate ? moment(participant.verSapAthDchDate).format(dateFormatShort) : '')} />
                                    </ListItem>
                                    <ListItem sx={{padding: '0px'}} disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={'Ath End: ' + (participant.verSapAthOvrlEndDate ? moment(participant.verSapAthOvrlEndDate).format(dateFormatShort) : '')} />
                                    </ListItem>
                                  </List>
                                </TableCell>
                                <TableCell align={'center'} >{participant.verIcnCDC}</TableCell>
                                <TableCell>{participant.verEpdId}</TableCell>
                                <TableCell>
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary='Individual:' />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary='Group:' />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary='Discharge:' />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary='Hours:' />
                                    </ListItem>
                                  </List>
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i1TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i1TmtTmtStsId ? verifyMasterReferenceData.i1TmtTmtStsIdList.find(x => x.id===participant.i1TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g1TmtTmtStsId ? verifyMasterReferenceData.g1TmtTmtStsIdList.find(x => x.id===participant.g1TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d1TmtTmtStsId ? verifyMasterReferenceData.d1TmtTmtStsIdList.find(x => x.id===participant.d1TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop1Hours? participant.stop1Hours: '-'} />
                                    </ListItem>
                                  </List>
                                  }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i2TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i2TmtTmtStsId ? verifyMasterReferenceData.i2TmtTmtStsIdList.find(x => x.id===participant.i2TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g2TmtTmtStsId ? verifyMasterReferenceData.g2TmtTmtStsIdList.find(x => x.id===participant.g2TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d2TmtTmtStsId ? verifyMasterReferenceData.d2TmtTmtStsIdList.find(x => x.id===participant.d2TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop2Hours? participant.stop2Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i3TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i3TmtTmtStsId ? verifyMasterReferenceData.i3TmtTmtStsIdList.find(x => x.id===participant.i3TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g3TmtTmtStsId ? verifyMasterReferenceData.g3TmtTmtStsIdList.find(x => x.id===participant.g3TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d3TmtTmtStsId ? verifyMasterReferenceData.d3TmtTmtStsIdList.find(x => x.id===participant.d3TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop3Hours? participant.stop3Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i4TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i4TmtTmtStsId ? verifyMasterReferenceData.i4TmtTmtStsIdList.find(x => x.id===participant.i4TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g4TmtTmtStsId ? verifyMasterReferenceData.g4TmtTmtStsIdList.find(x => x.id===participant.g4TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d4TmtTmtStsId ? verifyMasterReferenceData.d4TmtTmtStsIdList.find(x => x.id===participant.d4TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop4Hours? participant.stop4Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i5TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i5TmtTmtStsId ? verifyMasterReferenceData.i5TmtTmtStsIdList.find(x => x.id===participant.i5TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g5TmtTmtStsId ? verifyMasterReferenceData.g5TmtTmtStsIdList.find(x => x.id===participant.g5TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d5TmtTmtStsId ? verifyMasterReferenceData.d5TmtTmtStsIdList.find(x => x.id===participant.d5TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop5Hours? participant.stop5Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i6TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i6TmtTmtStsId ? verifyMasterReferenceData.i6TmtTmtStsIdList.find(x => x.id===participant.i6TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g6TmtTmtStsId ? verifyMasterReferenceData.g6TmtTmtStsIdList.find(x => x.id===participant.g6TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d6TmtTmtStsId ? verifyMasterReferenceData.d6TmtTmtStsIdList.find(x => x.id===participant.d6TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop6Hours? participant.stop6Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                                <TableCell align={'center'} >
                                  {participant.i7TmtDate?.substring(0,7) == month &&
                                  <List disablePadding>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.i7TmtTmtStsId ? verifyMasterReferenceData.i7TmtTmtStsIdList.find(x => x.id===participant.i7TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.g7TmtTmtStsId ? verifyMasterReferenceData.g7TmtTmtStsIdList.find(x => x.id===participant.g7TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.d7TmtTmtStsId ? verifyMasterReferenceData.d7TmtTmtStsIdList.find(x => x.id===participant.d7TmtTmtStsId).value.substring(0, 3): '-'} />
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemText sx={{margin: '0px'}} primary={participant.stop7Hours? participant.stop7Hours: '-'} />
                                    </ListItem>
                                  </List>
                                }
                                </TableCell>
                              </TableRow>
                                                           
                            )
                          })
                            



                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                <div className="page-break-after" />      
                </>
              }
            </div>
            </>
          ))
        }
      </Box>
    </>
  );
};

export default VerificationCreate;
